module.exports = __webpack_public_path__ + "img/close_bk.c50a56a.png";